import AuthService from './authservices';
import { HOST } from '../constants/routes';

const authService = new AuthService();

const apiBase = HOST;

export type MyJobRow = {
  job_id: string;
  college_name: string;
  season: number;
  sport_code: string | null;
  status: string;
  created_at?: string;
  updated_at?: string;
};

export type XmlFileRow = {
  path: string;
  size_bytes: number;
};

export async function fetchMyCompletedJobs(season: number, sportCode: string): Promise<MyJobRow[]> {
  const url = new URL(`${apiBase}/jobs/my-jobs`);
  url.searchParams.set('season', String(season));
  url.searchParams.set('sport_code', sportCode);
  const res = await authService.authenticatedFetch(url.toString(), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { detail?: string }).detail || 'Unable to load jobs.');
  }
  return res.json();
}

export async function fetchJobXmlFiles(jobId: string): Promise<{ xml_files: XmlFileRow[]; message?: string }> {
  const url = `${apiBase}/jobs/${jobId}/artifacts/xml-files`;
  const res = await authService.authenticatedFetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { detail?: string }).detail || 'Unable to load XML list.');
  }
  return res.json();
}

export async function fetchJobXmlContent(jobId: string, path: string): Promise<{ content: string; path: string }> {
  const url = new URL(`${apiBase}/jobs/${jobId}/artifacts/xml-content`);
  url.searchParams.set('path', path);
  const res = await authService.authenticatedFetch(url.toString(), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { detail?: string }).detail || 'Unable to load XML.');
  }
  return res.json();
}

export async function fetchJobRosterJson(jobId: string): Promise<{ data: unknown }> {
  const url = `${apiBase}/jobs/${jobId}/artifacts/roster-json`;
  const res = await authService.authenticatedFetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { detail?: string }).detail || 'Unable to load roster.');
  }
  return res.json();
}

export async function fetchJobScheduleJson(jobId: string): Promise<{ data: unknown }> {
  const url = `${apiBase}/jobs/${jobId}/artifacts/schedule-json`;
  const res = await authService.authenticatedFetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { detail?: string }).detail || 'Unable to load schedule.');
  }
  return res.json();
}
